import React, { useEffect, useState } from "react";
import Footer from "../../../../Kryzen Alpha App/Components/Footer/footer";
import StepRoutes from "../../../../Kryzen Alpha App/Routes/steps_routes";
import { useNavigate, useParams } from "react-router-dom";
import LoadingPage from "../../../../Kryzen Alpha App/Components/layouts/loading";
import { Toast } from "../../../../Kryzen Alpha App/CustomComponent/toast";
import performRequest from "../../../../Kryzen Alpha App/api/request";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { FcBusinessman, FcFilmReel, FcSelfServiceKiosk } from "react-icons/fc";
import SimpleButton from "../../../Components/layouts/simple_button";

const ViewCourceNameDetails = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  let { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/cource/course-view/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
        } else {
          Toast("error", "Error while getting cource!");
        }
        setLoading(false);
      })

      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) {
    return <LoadingPage />;
  }

  const linkifyText = (text) => {
    if (!text) return "N/A";

    const urlRegex = /(https?:\/\/[^\s]+)/g;

    return text.split(urlRegex).map((part, index) => {
      if (part.match(urlRegex)) {
        return (
          <a key={index} href={part} target="_blank" rel="noopener noreferrer">
            {part}
          </a>
        );
      }
      return part;
    });
  };

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title mb-1">
                  <FcSelfServiceKiosk className="fs-2 me-1" />
                  Course
                </h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
            </div>
          </div>
          <div className="card my-4">
            <div className="card-header">
              <h2 className="page-title">View Course Details</h2>
            </div>

            <div className="card-body">
              {!data ? (
                <div className="text-center text-muted">No data found</div>
              ) : (
                <>
                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">Course Name</label>
                    <div className="w-100 col">{data?.courseName || "N/A"}</div>
                  </div>

                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                    Course Description
                    </label>
                    <div className="w-100 col">
                      {data?.courseDes || "N/A"}
                    </div>
                  </div>

                 

    
                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                    ⁠Course first copy nas url{" "}
                    </label>
                    <div className="w-100 col">
                      {linkifyText(data?.courseUrl1) || "N/A"}
                    </div>
                  </div>

                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                    ⁠Course final nas url{" "}
                    </label>
                    <div className="w-100 col">
                      {linkifyText(data?.courseUrl2 || "N/A")}
                    </div>
                  </div>

                  {/* <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                    Published on website {" "}
                    </label>
                    <div className="w-100 col">
                      {data?.markaspublished ? "Yes" : "No" || "N/A"}
                    </div>
                  </div> */}

                  <div className="card-footer">
                    <div className="btn-list justify-content-end">
                      <SimpleButton
                        buttonText="Edit Course Details"
                        href={`/course-name-edit/${id}`}
                      />
                      <SimpleButton buttonText="Cancel" type="secondary" />
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default ViewCourceNameDetails;
